import React from 'react';
import cs from 'classnames';

// FIXME: for test
import LoginForm from '~/components/user/LoginForm';
import LoginFormV2 from '~/components/user/LoginFormV2';
import SignUpForm from '~/components/user/SignUpForm';
import ResetPasswordForm from '~/components/user/ResetPasswordForm';
import ResetPasswordOk from '~/components/user/ResetPasswordOk';
import LoadMapModal from '~/components/LoadMapModal';
import * as modes from '~/modules/modal/modes';
import Popup from '~/components/Popup';
import AddUserPop from '~/components/pages/AddUserPop';
import DotValidate from '~/components/DotValidate';
import EmailValidate from '~/components/Popup/EmailValidate';
import PhoneValidate from '~/components/Popup/PhoneValidate';
import PhoneSuccess from '~/components/Popup/PhoneSuccess';
import CreateBid from '~/components/Popup/CreateBid';
import CreateBidResult from '~/components/Popup/CreateBidResult'
import ProfileVerify from '~/components/Popup/ProfileVerify'
import RateUpdate from '~/components/rate/RateUpdate';
import RefreshHint from '~/components/Popup/RefreshHint';
import css from './index.css';
import SignUpNoCloseForm from '~/components/user/SignUpFormV2';
import Booking from '~/components/Popup/Booking';
import BookingLoadsmart from '~/components/Popup/BookingLoadsmart';
import RateModal from '~/pages/PostTruck/compontents/RateModal'
import BookingViewRC from '~/components/Popup/BookingViewRC';
import DotConfirm from '~/components/Popup/DotConfirm';
import NotInNetwork from '~/components/Popup/NotinNetwork';
import VerificationPending from '~/components/Popup/VerificationPending';
import Pending from '~/components/Popup/Pending';
import Booknow from '~/components/Popup/Booknow';
import DotUneditable from '~/components/Popup/DotUneditable';
import LoadsmartOnboard from '~/components/Popup/LoadsmartOnboard';
import L1Verification from '~/components/Popup/L1Verification';
import LoadsDisapper from '~/components/Popup/LoadsDisapper';
import MembershipPlans from '~/pages/MembershipPlans/components/PaymentModal';
import FuelSurchargePop from '~/components/Popup/FuelSurchargePop';
import SetAlertOnce from '~/components/Popup/SetAlertOnce';
import BidParade from '~/components/Popup/BidParade';
import NotinNetworkBid from '~/components/Popup/NotinNetworkBid';

const ErrorWrap = (props) => (
  <div className={cs(css.formError, 'qa-error-message')}>{props.children}</div>
);

const Content = ({uri, context, dispatch}) => {
  switch (uri) {
    case modes.LOGIN:
      return <div className={css.static}><LoginForm context={context} errorWrap={ErrorWrap}/></div>;
    case modes.LOGIN_V2:
      return <div className={css.static}><LoginFormV2 context={context} errorWrap={ErrorWrap}/></div>;
    case modes.RESET_PASSWORD:
      return <div className={css.static}><ResetPasswordForm context={context} errorWrap={ErrorWrap}/></div>;
    case modes.SIGNUP:
      return <div className={css.static}><SignUpForm context={context} errorWrap={ErrorWrap}/></div>;
    case modes.SIGNUP_V2:
      return <div className={css.noCloseStaic}><SignUpNoCloseForm context={context} errorWrap={ErrorWrap}/></div>;
    case modes.RESET_PASSWORD_OK:
      return (
        <div className={css.static}>
          <div className={css.spacedBlock}>
            <ResetPasswordOk context={context} errorWrap={ErrorWrap}/>
          </div>
        </div>
      );
    case modes.POP:
      return <Popup context={context} uri={uri} dispatch={dispatch} errorWrap={ErrorWrap}/>;
    case modes.ADDUSER:
      return <AddUserPop context={context} uri={uri} dispatch={dispatch} errorWrap={ErrorWrap}/>;
    case modes.DOT_VALIDATE:
      return (
        <div>
          <DotValidate uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      );
    case modes.EMAIL_VALIDATE: {
      return (
        <div>
          <EmailValidate uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      );
    }
    case modes.PHONE_VALIDATE: {
      return (
        <div>
          <PhoneValidate uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      );
    }
    case modes.PHONE_SUCCESS: {
      return (
        <div>
          <PhoneSuccess uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      );
    }
    case modes.CREATE_BID: {
      return (
        <div>
          <CreateBid uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    }
    case modes.CREATE_BID_RESULT: {
      return (
        <div>
          <CreateBidResult uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    }
    case modes.PROFILE_VERIFY: {
      return (
        <div>
          <ProfileVerify uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    }
    case modes.RATEUPDATE: {
      return (
        <div>
          <RateUpdate uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      );
    }
    case modes.BOOKNOW:{
      return (
        <div>
          <Booknow uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    }
    case modes.BOOKNOWLOADSMART:{
      return (
        <div>
          <BookingLoadsmart uri={uri} context={context} errorWrap={ErrorWrap} bookType={modes.BOOKNOWLOADSMART}/>
        </div>
      )
    }
    case modes.BOOKCANCEL:{
      return (
        <div>
          <Booking uri={uri} context={context} errorWrap={ErrorWrap} bookType={modes.BOOKCANCEL}/>
        </div>
      )
    }
    case modes.BOOKDELETE:{
      return (
        <div>
          <Booking uri={uri} context={context} errorWrap={ErrorWrap} bookType={modes.BOOKDELETE}/>
        </div>
      )
    }
    case modes.REFRESH_HINTS: 
      return (
        <div>
          <RefreshHint uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.POSTTRUCK_RATE:
      return (
        <div>
          <RateModal uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.BOOKRC_VIEW: 
      return (
        <div>
          <BookingViewRC uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.DOT_CONFIRM: 
      return (
        <div>
          <DotConfirm uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.NOT_IN_NETWORK: 
      return (
        <div>
          <NotInNetwork uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.NOT_IN_NETWORK_BID: 
      return (
        <div>
          <NotinNetworkBid uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.VERIFICATION_PENDING : 
      return (
        <div>
          <VerificationPending uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.PENDING : 
      return (
        <div>
          <Pending uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.DOT_UNEDITABLE: 
      return (
        <div>
          <DotUneditable uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.LOADSMART_ONBOARD: 
      return (
        <div>
          <LoadsmartOnboard uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.NEED_L1: 
      return (
        <div>
          <L1Verification uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
    case modes.LOAD_DISAPPER: 
      return (
        <div>
          <LoadsDisapper uri={uri} context={context} errorWrap={ErrorWrap}/>  
        </div>
      )
    case modes.MEMBERSHIP_PLANS:
      return (
        <div>
          <MembershipPlans uri={uri} context={context} errorWrap={ErrorWrap} />
        </div>
      );

    case modes.BID_PARADE: 
      return (
        <div>
          <BidParade uri={uri} context={context} errorWrap={ErrorWrap} />
        </div>
      )

    case modes.FUEL_SURCHANGE: 
      return (
        <div>
          <FuelSurchargePop uri={uri} context={context} errorWrap={ErrorWrap}/>
        </div>
      )
      
    case modes.SET_ALERT_ONCE: 
      return (
        <div>
          <SetAlertOnce uri={uri} context={context} errorWrap={ErrorWrap} />
        </div>
      )
  }

  if (uri.startsWith('loadmap')) {
    return <LoadMapModal loadId={uri.split('/')[1]}/>;
  }

  return null;
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/Modal/Content/index.js